import { Button, Tooltip, Typography } from "@mui/material";
import { Cancel as CancelIcon } from "@mui/icons-material";
import { Link, useLocation } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

import { useCase } from "src/hooks/useCase";
import { UsersIcon } from "src/components/icons/UsersIcon";
import { ShareIcon } from "src/components/icons/ShareIcon";

export function CaseLayoutTitle(props: { caseId: string | number }) {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  if (pathname.includes("/cases/new")) {
    return (
      <Styles>
        <div className="case-title">
          <span className="title">{t("label.newCase")}</span>
        </div>
      </Styles>
    );
  } else {
    return <CaseTitle caseId={props.caseId} />;
  }
}

function CaseTitle(props: { caseId: string | number }) {
  const { t } = useTranslation();
  const { data: acase } = useCase(props.caseId);

  return render();

  function render() {
    if (!acase) return null;

    return (
      <Styles className="case-title">
        {acase.sharedCase && (
          <Tooltip title={t("label.sharedWithYou")}>
            <span className="shared-icon-wrap">
              <UsersIcon className="shared-users-icon" />
            </span>
          </Tooltip>
        )}
        {!acase.sharedCase && acase.sharedEmailList.length > 0 && (
          <Tooltip title={t("label.youAreSharingThisCaseWithOthers")}>
            <span className="shared-icon-wrap">
              <ShareIcon className="shared-share-icon" />
            </span>
          </Tooltip>
        )}
        <Typography className="title">{acase.name}</Typography>
        <Tooltip title={t("label.runYear")}>
          <Typography variant="body2" className="run-year">
            {acase.runYear}
          </Typography>
        </Tooltip>
        <Button component={Link} to="/cases" className="close-btn" size="small" startIcon={<CancelIcon />}>
          {t("label.close")}
        </Button>
      </Styles>
    );
  }
}

const Styles = styled("div")`
  margin-left: ${({ theme }) => theme.caseDrawer.width}px;
  align-items: center;
  display: flex;
  height: 100%;
  gap: ${({ theme }) => theme.spacing(1)};
  .title {
    color: #000;
    font-weight: 600;
  }
  .run-year {
    transform: translateY(1px);

    font-weight: bold;
  }
  .close-btn {
    margin-left: ${({ theme }) => theme.spacing(2)};
    color: #aaa;
    svg {
      transform: translateY(-1px);
    }
  }
  .shared-icon-wrap {
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-right: 4px;
    transform: translateY(-1px);
    svg {
      width: 100%;
      height: 100%;
    }
  }
  .shared-users-icon {
    color: #9d63d8;
  }
  .shared-share-icon {
    color: ${({ theme }) => theme.palette.primary.main};
  }
`;
